import type { SVGProps } from 'react';
export const Language = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M4.81 7.77a5.63 5.63 0 0 0 4.78 7.86l.13-.67-1.18-1.28a1.2 1.2 0 0 1-.22-1.31l.42-.93a1.2 1.2 0 0 1-.93-.66v-.01l-.22-.45-1.34-.29a1.2 1.2 0 0 1-.88-.77zm1.1-.94.56 1.51.2-.46a1.2 1.2 0 0 1 1.1-.74h1.38l.75-.42 1.68-1.5-.41-.74A5.7 5.7 0 0 0 6.4 5.64zm5.8-3.62A7 7 0 0 0 3 10a7 7 0 1 0 8.72-6.79m1.26 1.99a5.64 5.64 0 0 1 2.38 6.6l-2.89-1.78q-.21-.14-.48-.17l-1.5-.2a1.2 1.2 0 0 0-1.1.44h-.4l-.2-.43a1.2 1.2 0 0 0-.84-.65l-.25-.06.19-.45H9.2q.29 0 .55-.15l.82-.45q.12-.07.23-.17l1.76-1.6h.01a1.2 1.2 0 0 0 .39-.93M10.42 11l-.82 1.83 1.17 1.27a1.2 1.2 0 0 1 .3 1.04l-.08.42a5.7 5.7 0 0 0 3.78-2.53l-3-1.84zm-.54-4.26"
      clipRule="evenodd"
    />
  </svg>
);
